import { useEffect } from 'react';
import { useTranslation } from '../i18n/LanguageContext';
import type { Locale } from '../i18n/translations';

const locales: { code: Locale; label: string }[] = [
  { code: 'en', label: 'EN' },
  { code: 'de', label: 'DE' },
  { code: 'ru', label: 'RU' },
  { code: 'fr', label: 'FR' },
];

export default function Header() {
  const { t, locale, setLocale } = useTranslation();

  useEffect(() => {
    document.title = `${t.title} — Compress Images in ZIP & RAR Online`;
  }, [t]);

  return (
    <header className="header">
      <div className="lang-switcher">
        {locales.map((l) => (
          <button
            key={l.code}
            className={`lang-btn ${locale === l.code ? 'lang-btn-active' : ''}`}
            onClick={() => setLocale(l.code)}
          >
            {l.label}
          </button>
        ))}
      </div>
      <div className="logo-link">
        <img src="/logo.png" alt="Logo" className="logo" />
        <h1>{t.title}</h1>
      </div>
      <p>{t.subtitle}</p>
    </header>
  );
}
